export function getStockMediaNavOptions() {
    return {
        STOCK_FOOTAGE: 'stock-footage',
        BACKGROUNDS: 'animated-backgrounds',
        TEMPLATES: 'Templates',
    };
}
export function getAudioNavOptions() {
    return {
        MUSIC: 'royalty-free-music',
        EFFECTS: 'sound-effects',
    };
}
export function getTemplateNavOptions() {
    return {
        PREMIERE_PRO: 'premiere-pro-templates',
        AFTER_EFFECTS: 'after-effects-templates',
        DAVINCI_RESOLVE: 'davinci-resolve-templates',
        APPLE_MOTION: 'apple-motion-templates',
    };
}
export var OtherCategoryTypes;
(function (OtherCategoryTypes) {
    OtherCategoryTypes["CREATIVE_TOOLS"] = "creative-tools";
    OtherCategoryTypes["BUSINESS"] = "business";
    OtherCategoryTypes["RESOURCES"] = "resources";
})(OtherCategoryTypes || (OtherCategoryTypes = {}));
export var PlanClassification;
(function (PlanClassification) {
    PlanClassification["LEGACY_PLAN_CLASSIFICATION"] = "Legacy";
    PlanClassification["BASIC_PLAN_CLASSIFICATION"] = "Basic";
    PlanClassification["STARTER_PLAN_CLASSIFICATION"] = "Starter";
    PlanClassification["BUNDLE_PLAN_CLASSIFICATION"] = "Bundle";
    PlanClassification["UNLIMITED_PLAN_CLASSIFICATION"] = "Unlimited";
    PlanClassification["ENTERPRISE_PLAN_CLASSIFICATION"] = "Enterprise";
    PlanClassification["GROWTH_PLAN_CLASSIFICATION"] = "Growth";
    PlanClassification["PRO_PLAN_CLASSIFICATION"] = "Pro";
})(PlanClassification || (PlanClassification = {}));
